// 售前订单的一些常量

//本地订单状态:0是全部订单 10是待下单，20是已下单待发货，30是已发货，40是极速退款，50是退款中，60是已取消
export const DyOrders_LocalStatus_All = {
  value: 0,
  EnglishName: "all",
  name: "全部订单",
};
export const DyOrders_LocalStatus_WaitBuy = {
  value: 10,
  EnglishName: "waitBuy",
  name: "待下单",
};
export const DyOrders_LocalStatus_WaitSend = {
  value: 20,
  EnglishName: "waitSend",
  name: "已下单待发货",
};
export const DyOrders_LocalStatus_SendOk = {
  value: 30,
  EnglishName: "sendOk",
  name: "已发货",
};
export const DyOrders_LocalStatus_AfterSales = {
  value: 80,
  EnglishName: "afterSales",
  name: "售后中",
};

export const DyOrders_LocalStatus_Received = {
  value: 40,
  EnglishName: "received",
  name: "已签收",
};

export const DyOrders_LocalStatus_Complete = {
  value: 45,
  EnglishName: "complete",
  name: "已完成",
};

export const DyOrders_LocalStatus_Refund_Success = {
  value: 50,
  EnglishName: "Refund",
  name: "退款成功",
};

export const DyOrders_LocalStatus_Cancel = {
  value: 60,
  EnglishName: "Cancel",
  name: "取消订单",
};

// 售前订单状态的一个集合
export const localStatusList = [
  DyOrders_LocalStatus_All,
  DyOrders_LocalStatus_WaitBuy,
  DyOrders_LocalStatus_WaitSend,
  DyOrders_LocalStatus_SendOk,
  DyOrders_LocalStatus_AfterSales,
  DyOrders_LocalStatus_Received,
  DyOrders_LocalStatus_Refund_Success,
  DyOrders_LocalStatus_Cancel,
];

// 关联订单状态
export const Orders_ConcatStatus = {
  justCreat: 0,
  hasOrderNum: 10,
  isTransport: 20,
};

// 发货状态
export const DyOrders_OrderStatus = {
  //待发货
  waitSend: 1,
  //已发货
  alreadySend: 2,
  //已关闭
  isFinish: 3,
};
